<div class="account-pages my-5 pt-sm-5">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-primary-subtle">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Welcome to Client Portal!</h5>
                  <p>Sign in to continue to your VM dashboard.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="assets/images/profile-img.png" alt="" class="img-fluid">
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <a routerLink="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="assets/images/logo.svg" alt="" class="rounded-circle" height="34">
                  </span>
                </div>
              </a>
            </div>
            <div class="p-2">
              <form class="form-horizontal" (ngSubmit)="onLogin()" #loginForm="ngForm">
                <div class="mb-3">
                  <label for="username">Username</label>
                  <input type="text" class="form-control" id="username" placeholder="Enter username" 
                         [(ngModel)]="username" name="username" required>
                </div>

                <div class="mb-3">
                  <label class="form-label" for="userpassword">Password</label>
                  <input type="password" class="form-control" id="userpassword" placeholder="Enter password" 
                         [(ngModel)]="password" name="password" required>
                </div>

                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="customControlInline">
                  <label class="form-check-label" for="customControlInline">Remember me</label>
                </div>

                <div class="mt-3 d-grid">
                  <button class="btn btn-primary waves-effect waves-light" type="submit" 
                          [disabled]="!loginForm.form.valid || isLoading">
                    <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span *ngIf="isLoading">Loading...</span>
                    <span *ngIf="!isLoading">Log In</span>
                  </button>
                </div>

                <div class="mt-4 text-center">
                  <a routerLink="/recover-password" class="text-muted">
                    <i class="mdi mdi-lock me-1"></i> Forgot your password?
                  </a>
                </div>
                
                <div class="mt-4 text-center" *ngIf="errorMessage" class="alert alert-danger" role="alert">
                  {{ errorMessage }}
                </div>
              </form>
            </div>

          </div>
        </div>
        <div class="mt-5 text-center">
          <p>Are you an administrator? <a routerLink="/log-in" class="fw-medium text-primary"> Sign in as Admin</a> </p>
          <p>© {{ getCurrentYear() }} Insightful IT Services. Crafted with <i class="mdi mdi-heart text-danger"></i> by Themesbrand</p>
        </div>
      </div>
    </div>
  </div>
</div>